import React from "react";
import { SxProps, Theme } from "@mui/material";
import DSBox from "./DSBox";
import DSTypography from "./DSTypography";

type DSSectionHeadingProps = {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
};

// Yellow overline section heading with a short accent bar underneath.
// Default px/pt matches the card placement used across section cards;
// override via `sx` when a call site needs different spacing.
const DSSectionHeading = ({ children, sx }: DSSectionHeadingProps) => (
  <DSBox sx={[{ px: 2, pt: 2 }, ...(Array.isArray(sx) ? sx : [sx])]}>
    <DSTypography
      sx={{
        fontSize: "12px",
        fontFamily: "Gilroy-SemiBold",
        textTransform: "uppercase",
        letterSpacing: "0.12em",
        color: "surface.accentText",
      }}
    >
      {children}
    </DSTypography>
    <DSBox
      sx={{
        width: "28px",
        height: "2px",
        borderRadius: "2px",
        backgroundColor: "primary.main",
        opacity: 0.9,
        mt: 0.75,
      }}
    />
  </DSBox>
);

export default DSSectionHeading;
